import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

const ShareModal = ({ reportLink, show, handleClose }) => {
  const [customNumber, setCustomNumber] = useState('+91');
  const [errorMessage, setErrorMessage] = useState('');

  const isValidNumber = (number) => number.length === 13;

  const openWhatsApp = (url) => {
    window.open(
      url,
      '_blank',
      'width=600,height=700,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no'
    );
  };

  const handleWhatsAppShare = () => {
    const baseUrl = 'https://wa.me/';
    if (!customNumber || customNumber === '+91') {
      const url = `${baseUrl}?text=${encodeURIComponent(reportLink)}`;
      openWhatsApp(url);
      setErrorMessage('');
      handleClose();
    } else if (isValidNumber(customNumber)) {
      const url = `${baseUrl}${customNumber}?text=${encodeURIComponent(reportLink)}`;
      openWhatsApp(url);
      setErrorMessage('');
      handleClose();
    } else {
      setErrorMessage('Please enter a valid 10-digit WhatsApp number.');
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(reportLink);
    toast.success('Link copied to clipboard!');
    handleClose();
  };

  const formatPhoneNumber = (value) => {
    const digitsOnly = value.replace(/\D/g, '');
    const cleanedValue = digitsOnly.startsWith('91')
      ? digitsOnly.slice(2)
      : digitsOnly.startsWith('1')
      ? digitsOnly.slice(1)
      : digitsOnly;

    return '+91' + cleanedValue;
  };

  const handleInputChange = (e) => {
    const formattedNumber = formatPhoneNumber(e.target.value);
    setCustomNumber(formattedNumber);

    if (formattedNumber.length === 13 || formattedNumber === '+91') {
      setErrorMessage('');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Share Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formWhatsAppNumber">
          <Form.Label>WhatsApp Number</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter WhatsApp number"
            value={customNumber}
            onChange={handleInputChange}
            maxLength={13}
            isInvalid={!!errorMessage}
          />
          {errorMessage && <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleWhatsAppShare}>
          Share on WhatsApp
        </Button>
        <Button variant="primary" onClick={handleCopyLink}>
          Copy Link
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareModal;
